/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Invite_Codes_Count_LabelInputs */

const en_admin_invite_codes_count_label = /** @type {(inputs: Admin_Invite_Codes_Count_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How many`)
};

/**
* | output |
* | --- |
* | "How many" |
*
* @param {Admin_Invite_Codes_Count_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_invite_codes_count_label = /** @type {((inputs?: Admin_Invite_Codes_Count_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Invite_Codes_Count_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_invite_codes_count_label(inputs)
});
export { admin_invite_codes_count_label as "admin.invite_codes.count_label" }